/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.activities.participation-requirements'},
});

const ParticipationRequirementsItem = () => (
  <RouteLinkItem
    route="midas/settings/activities/activities-requirements"
    title={messages.title}
  />
);

export default ParticipationRequirementsItem;
